import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as updatesAPI from '@debbie/cortex/dist/api/updates.js';
import q from '@debbie/cortex/dist/query.js';
import { updatesEntity } from '@debbie/cortex/dist/updates/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../theme.js';
import { errorNotification } from '../utils/errors.js';
import Pause from './Icons/Pause.js';
import PlusCircle from './Icons/PlusCircle.js';
import { Button, DateInput, Input, RadioSelect } from './index.js';
// Imported directly (not via the barrel) because styled(UpdateTypeSelect)
// runs at module init, where the circular barrel import is still undefined
import UpdateTypeSelect from './UpdateTypeSelect.js';
var PauseOption;
(function (PauseOption) {
    PauseOption["NOW"] = "NOW";
    PauseOption["PAUSEAT"] = "PAUSEAT";
    PauseOption["CONTINUE"] = "CONTINUE";
})(PauseOption || (PauseOption = {}));
const NewPause = (props) => {
    const now = moment();
    const lang = useSelector((s) => s.lang);
    const [updateTypeId, setUpdateTypeId] = useState(null);
    const [note, setNote] = useState('');
    const [remindedAt, setRemindedAt] = useState(now);
    const [pauseOption, setPauseOption] = useState(PauseOption.NOW);
    const singleCase = props.case;
    const pauseCaseMutation = useMutation(() => {
        if (!updateTypeId) {
            throw new Error('Please select a type of update');
        }
        return updatesAPI.make({
            referenceId: singleCase.caseId,
            updateTypeId: updateTypeId,
            update: note || null,
            remindedAt: remindedAt.format(),
            pausedAt: [PauseOption.NOW, PauseOption.CONTINUE].includes(pauseOption)
                ? now === remindedAt
                    ? remindedAt.format()
                    : undefined
                : remindedAt.format(),
            continuedAt: PauseOption.CONTINUE === pauseOption
                ? remindedAt.format()
                : undefined,
        });
    }, {
        onSuccess: () => {
            q.invalidate(keys.write.create(updatesEntity));
            setUpdateTypeId(null);
            setNote('');
            setRemindedAt(now);
            setPauseOption(PauseOption.NOW);
            props.toggleNewUpdate();
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.pause);
        },
    });
    const pauseCase = () => {
        pauseCaseMutation.mutate();
    };
    const formattedDate = remindedAt.format(THEME.DATE_FORMAT_SHORT);
    return (singleCase && (React.createElement(StyledPause, null,
        React.createElement(PlusCircle, { style: {
                margin: '0.9em 0.4em 0.9em 0em',
            } }),
        React.createElement(InputWrapper, null,
            React.createElement("div", { style: { marginBottom: `-${THEME.GRID_SPACING}px` } },
                React.createElement(PauseUpdateTypeSelect, { value: updateTypeId, onChange: (updateTypeId) => setUpdateTypeId(updateTypeId), filter: (updateType) => updateType.selectable, autofocus: true, className: "ui-test-3cf24ad6", placeholder: lang.cases.pauseReason }))),
        React.createElement(InputWrapper, null,
            React.createElement(Input, { value: note, style: { margin: `0px` }, placeholder: lang.cases.pauseComment, onChange: (e) => {
                    setNote(e.target.value);
                } })),
        React.createElement(InputWrapper, { "data-tooltip-id": "tooltip-top", "data-tooltip-content": lang.updates.dateSelectorTooltip },
            React.createElement(DateInput, { value: remindedAt, showTimeSelect: true, allowNull: false, placeholder: lang.updates.remindDate, style: { margin: 0 }, onChange: (date) => setRemindedAt(date) })),
        React.createElement(OptionsWrapper, null, now !== remindedAt && (React.createElement(React.Fragment, null,
            React.createElement(RadioSelect, { active: pauseOption === PauseOption.NOW, key: PauseOption.NOW, label: lang.updates.pauseNow, onClick: () => setPauseOption(PauseOption.NOW) }),
            React.createElement(RadioSelect, { active: pauseOption === PauseOption.PAUSEAT, key: PauseOption.PAUSEAT, label: `${lang.updates.pauseUntilReminding} ${formattedDate}`, onClick: () => setPauseOption(PauseOption.PAUSEAT) }),
            React.createElement(RadioSelect, { active: pauseOption === PauseOption.CONTINUE, key: PauseOption.CONTINUE, label: `${lang.updates.pauseContinueAt} ${formattedDate}`, onClick: () => setPauseOption(PauseOption.CONTINUE) })))),
        React.createElement(Button, { blockOnMobile: true, loading: pauseCaseMutation.isLoading, disabled: !updateTypeId, className: "ui-test-6ab08a95", onClick: pauseCase },
            React.createElement(Pause, { style: {
                    margin: '.2em 0 -.2em',
                } }),
            ' ',
            lang.cases.pauseCase))));
};
export default NewPause;
const StyledPause = styled.div `
  display: flex;
  justify-content: space-between;
  margin-bottom: ${THEME.GRID_SPACING}px;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    display: block;
    .react-datepicker-wrapper,
    .react-datepicker__input-container {
      display: block;
    }
  }

  padding: ${THEME.GRID_SPACING}px;
  background-color: ${THEME.COLOR_SECONDARY};
  color: ${THEME.COLOR_PRIMARY};
  border-radius: 5px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

  .react-datepicker-wrapper {
    width: auto !important;
  }
`;
const OptionsWrapper = styled.div `
  flex-grow: 1;
  padding: 9px 0;
`;
const InputWrapper = styled.div `
  margin-right: ${THEME.GRID_SPACING}px;

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    margin-right: 0px;
    margin-bottom: 20px;
  }
`;
// Fixed width so the trigger doesn't grow/shrink with the selected label
const PauseUpdateTypeSelect = styled(UpdateTypeSelect) `
  && {
    width: 230px;

    @media ${THEME.MEDIA_QUERY_MOBILE} {
      width: 100%;
    }
  }
`;
//# sourceMappingURL=NewPause.js.map